import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-carousel-courses.tsx
var LazyCarouselCourses = lazy(() => import("./carousel-courses-3toOAi9G.js").then((n) => n.n).then((module) => ({ default: module.CarouselCourses })));
function CarouselCourses({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel-courses" }),
		children: /* @__PURE__ */ jsx(LazyCarouselCourses, { ...props })
	});
}
function CarouselCoursesContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel-courses" }),
		children: /* @__PURE__ */ jsx(LazyCarouselCourses, { ...props })
	});
}
var useCarouselCoursesContent = () => {
	return useMemo(() => ({ carouselCourses: { component: CarouselCoursesContent } }), []);
};
//#endregion
export { CarouselCourses, useCarouselCoursesContent };
